import React from "react";
import DeviceAssociateModal from "./DeviceAssociateModal";
import ApplicationAssociateModal from "./ApplicationAssociateModal";

function AssociateModal({
    displayMode,
    t,
    isAssociateModalOpened,
    setIsAssociateModalOpened,
    rowData,
    globalDataIsUpdated,
    setGlobalDataIsUpdated,
    oneShop,
    selectedRows,
}: any) {
    const isDeviceMode = displayMode !== t("View by device");

    return (
        <>
            {isDeviceMode ? (
                <DeviceAssociateModal
                    setIsDeviceAssociateModalOpened={setIsAssociateModalOpened}
                    isDeviceAssociateModalOpened={isAssociateModalOpened}
                    rowData={rowData}
                    dataIsUpdated={globalDataIsUpdated}
                    setDataIsUpdated={setGlobalDataIsUpdated}
                    oneShop={oneShop}
                    selectedRows={selectedRows}
                />
            ) : (
                <ApplicationAssociateModal
                    setIsDeviceAssociateModalOpened={setIsAssociateModalOpened}
                    isDeviceAssociateModalOpened={isAssociateModalOpened}
                    rowData={rowData}
                    dataIsUpdated={globalDataIsUpdated}
                    setDataIsUpdated={setGlobalDataIsUpdated}
                    selectedRows={selectedRows}
                />
            )}
        </>
    );
}

export default AssociateModal;
